import { Button } from '@heroui/react'

export interface FilterChipOption {
  key: string
  label: string
  /** Rendered as "Label (n)". Omit where no cheap count exists. */
  count?: number
}

interface StatusFilterChipsProps {
  /** Group label for assistive tech — say what is being filtered. */
  ariaLabel: string
  options: FilterChipOption[]
  active: string
  onChange: (key: string) => void
}

/**
 * One-click status filter row shared by the Review screen, the History list and
 * the History details view. A chip is a toggle within a single-select group:
 * the active key is always one of `options` (conventionally "all" first), so
 * clicking the active chip is a no-op rather than a deselect.
 */
export default function StatusFilterChips({
  ariaLabel,
  options,
  active,
  onChange,
}: StatusFilterChipsProps) {
  return (
    <div aria-label={ariaLabel} className="flex flex-wrap gap-2" role="group">
      {options.map(option => {
        const isActive = option.key === active

        return (
          <Button
            key={option.key}
            aria-pressed={isActive}
            color={isActive ? 'primary' : 'default'}
            radius="full"
            size="sm"
            variant={isActive ? 'solid' : 'bordered'}
            onPress={() => onChange(option.key)}
          >
            {option.label}
            {option.count !== undefined && (
              <span className={isActive ? 'opacity-80' : 'text-gray-500 dark:text-[#AFAFAF]'}>
                ({option.count.toLocaleString()})
              </span>
            )}
          </Button>
        )
      })}
    </div>
  )
}
